/* eslint-disable react-refresh/only-export-components */
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

const badgeVariants = cva(
  "ax-badge focus:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring/40",
  {
    variants: {
      variant: {
        default: "ax-badge--primary ax-badge--tonal",
        secondary: "ax-badge--neutral",
        destructive: "ax-badge--critical ax-badge--tonal",
        critical: "ax-badge--critical ax-badge--tonal",
        outline: "ax-badge--outline",
        success: "ax-badge--success ax-badge--tonal",
        warning: "ax-badge--warning ax-badge--tonal",
        info: "ax-badge--info ax-badge--tonal",
        caution: "ax-badge--caution ax-badge--tonal",
        neutral: "ax-badge--neutral",
        stable: "ax-badge--neutral",
        elevated: "ax-badge--info ax-badge--tonal",
        improving: "ax-badge--success ax-badge--tonal",
      },
      size: {
        xs: "ax-badge--xs",
        sm: "",
        md: "ax-badge--md",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "sm",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
  VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <span className={badgeVariants({ variant, size, className })} {...props} />
  )
}

export { Badge, badgeVariants }
